<div class="input cbwf-info-action-popover run-input-required">
    <div class="remove"><span class="glyphicon glyphicon-remove remove"></span></div>
    <div class="caption">{{message}}</div>
    
    <div class="has-advanced-inputs">
        The paused input step uses advanced input options.
        <a href="{{redirectApprovalUrl}}">Please redirect to approve</a>.
    </div>

</div>